export default "__VITE_ASSET__Vb71kaEr__"